import * as React from "react";

import { cn } from "../../lib/utils";

const InputGroup = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("flex w-full items-stretch", className)} {...props} />
  ),
);
InputGroup.displayName = "InputGroup";

const InputGroupText = React.forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement>>(
  ({ className, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-md border border-input bg-muted px-3 text-base text-muted-foreground md:text-sm",
        className,
      )}
      {...props}
    />
  ),
);
InputGroupText.displayName = "InputGroupText";

export { InputGroup, InputGroupText };
